<template>
  <div class="card">
    <img v-if="renderSrc" :src="renderSrc" alt="分享图" style="width: 100%">
    <div v-else id="live-share-card" ref="root">
      <div :style="`background-image:url(${$changeCDN(liveInfo.poster)||$defaultSrc})`" class="poster"></div>
      <div :style="`background-image:url(${$changeCDN(liveInfo.poster)||$defaultSrc})`" class="mirror-bg"></div>
      <div class="content">
        <div class="anchor align">
          <img :src="$changeCDN(anchor.avatar)" alt="头像" class="avatar">
          <div>
            <div class="name">{{ anchor.name }}</div>
            <div v-if="isAllDay" class="time">直播日期：{{ liveInfo.startTime ? $formatTime(liveInfo.startTime, 'YYYY-MM-DD') : '-' }}</div>
            <div v-else class="time">直播场次：{{ liveInfo.startTime ? $formatTime(liveInfo.startTime * 1000, 'YYYY-MM-DD HH:mm') : '-' }}</div>
          </div>
        </div>
        <div v-if="commodityList.length!==0 || isAllDay" class="statistic">
          <div class="orange">
            <div class="left">
              <div>
                上架商品
                <span class="number-font">{{ isVIP ? $_.get(liveInfo, 'barrage.shopCarCommodity') : '****' }}</span>
              </div>
              <div class="divider"></div>
              <div>
                直播销量
                <span class="number-font">{{ isVIP ? $retainWan(salesVolume) : '****' }}</span>
              </div>
            </div>
            <div class="right">
              <div class="label">本场销售额（元）</div>
              <div class="data">
                <template v-if="isVIP">
                  <span class="number-font">{{ $splitWan(liveInfo.sales).num }}</span>
                  <span style="font-size: 0.28rem;">{{ $splitWan(liveInfo.sales).unit }}</span>
                </template>
                <span v-else class="number-font">****</span>
              </div>
            </div>
          </div>
          <!--俩蓝色框-->
          <div class="between">
            <div v-if="isYearVIP" class="color-block blue">
              <div>总观看人数（直播UV）</div>
              <div class="number-font">{{ $retainWan(uv, 2, true) }}</div>
            </div>
            <div v-else class="color-block blue">
              <div>最高在线人数</div>
              <div class="number-font">{{ $retainWan($_.get(liveInfo, 'barrage.liveMaxView'), 2, true) }}</div>
            </div>
            <div class="blue">
              <div>本场客单价</div>
              <div class="number-font">¥ {{ salesVolume ? (liveInfo.sales / salesVolume).toFixed(2) : '-' }}</div>
            </div>
          </div>
        </div>
        <!--未卖货-->
        <div v-else class="no-sales ">
          <div class="between">
            <div v-if="isYearVIP" class="color-block blue">
              <div>总观看人数（直播UV）</div>
              <div class="number-font">{{ $retainWan(uv, 2, true) }}</div>
            </div>
            <div v-else class="color-block blue">
              <div>最高在线人数</div>
              <div class="number-font">{{ $retainWan($_.get(liveInfo, 'barrage.liveMaxView'), 2, true) }}</div>
            </div>
            <div class="color-block yellow">
              <div>人均停留时长</div>
              <div class="number-font">{{ avgDuration }}</div>
            </div>
          </div>
          <div class="detail">
            <div v-if="isYearVIP" class="block">
              <div class="label">最高在线人数</div>
              <div class="number-font">{{ $retainWan($_.get(liveInfo, 'barrage.liveMaxView'), 2, true) }}</div>
            </div>
            <div v-else class="block">
              <div class="label">弹幕总数</div>
              <div class="number-font">{{ $retainWan($_.get(liveInfo, 'barrage.barrageCount')) }}</div>
            </div>
            <div v-else class="block">
              <div class="label">最高在线人数</div>
              <div class="number-font">{{ $retainWan($_.get(liveInfo, 'barrage.liveMaxView'), 2, true) }}</div>
            </div>
            <div class="block">
              <div class="label">平均在线人数</div>
              <div class="number-font">{{ $retainWan(liveAvgView) || '-' }}</div>
            </div>
            <div class="block">
              <div class="label">互动人数</div>
              <div class="number-font">{{ $retainWan(interactive) }}</div>
            </div>
          </div>
        </div>
        <div class="qrcode-container">
          <img src="https://s6.bihukankan.com/img/0326logo-tips.png" alt="扫码" class="qr-tips">
          <img :src="qrcode" alt="qrcode" class="qrcode">
        </div>
      </div>
    </div>
    <div class="tips align between">
      <div class="align">提示：长按上图即可保存到手机相册</div>
      <div class="close" @click="$router.go(-1)">返回</div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import moment from 'moment'

export default {
  data() {
    return {
      /**
       * @type {{
       *   poster:string,
       *   startTime:number,
       *   sales:string,
       *   viewsCount:number
       * }}
       */
      liveInfo: {},
      anchor: {},
      commodityList: [],
      renderSrc: '',
      isVIP: this.$store.state.userLevel && this.$store.state.userLevel <= 100,
      isYearVIP: this.$store.state.userLevel && this.$store.state.userLevel <= 95,
      qrcode: 'https://s6.bihukankan.com/img/0326miniprogram.png',
      // id 为 '20210327' 的八位日期时，代表整日直播
      isAllDay: (this.$route.params.id || []).length === 8
    }
  },
  computed: {
    uv() {
      if (this.liveInfo.date < 20210310) {
        return '暂无'
      }
      return this.isAllDay ? this.liveInfo.uv : this.liveInfo?.barrage?.viewsCount
    },
    salesVolume() {
      if (this.isAllDay) {
        return this.liveInfo.salesVolume || '-'
      }
      let result = 0
      for (const item of this.commodityList) {
        result += item.salesVolume
      }
      return result
    },
    // barrage中的平均在线非会员没有
    liveAvgView() {
      const abbr = this.$_.get(this.liveInfo, 'barrage.liveChart', []);
      let sum = 0;
      for (const live of abbr) {
        sum += live.views;
      }
      return parseInt(sum / abbr.length);
    },
    interactive() {
      let sum = 0
      for (const item of this.liveInfo?.barrage?.liveChart || []) {
        sum += item.interactive
      }
      return sum
    },
    avgDuration() {
      if (!this.isYearVIP) {
        return '****'
      }
      if (isNaN(this.uv)) {
        return '-'
      }
      const unix = (this.liveInfo.stopTime - this.liveInfo.startTime) / (this.uv / this.liveInfo?.barrage?.liveAvgView)
      const hours = parseInt(unix / 3600)
      const minutes = parseInt(unix / 60) % 60
      const secounds = parseInt(unix % 60)
      if (hours) {
        return `${hours}时${minutes}分`
      }
      return minutes ? `${minutes}分${secounds}秒` : secounds + '秒'
    },
  },
  async mounted() {
    this.$showLoading('正在生成分享图');
    window.scrollTo(0, 0)
    if (this.isAllDay) {
      await this.getAllDayData()
    } else {
      await this.getLiveData()
    }
    // const res = await this.$api({
    //   method: 'post',
    //   url: 'v1.1.0/link',
    //   data: {
    //     type: 'MINI',
    //     app: 'KANKAN_MINI',
    //     redirect: this.isAllDay ? `/anchor/${this.$route.params.anchorId}?banner=2` : `/live/${this.$route.params.anchorId}/${this.$route.params.id}`,
    //     params: 'asd',
    //     page: 'pages/main/main'
    //   }
    // })
    // this.qrcode = res.link
    await this.$nextTick()
    // 直播日历使用scroll-behavior: smooth; 需要等待滚动动画结束再操作,亲测在安卓小程序上400ms还不够。。
    setTimeout(() => {
      this.createImage()
    }, 500);
  },
  methods: {
    async getAllDayData() {
      const start = moment(this.$route.params.id).unix()
      let [anchor, liveList] = await Promise.all([
        this.$api.get('v1.1.0/gifshow/anchor/' + this.$route.params.anchorId),
        this.$api({
          method: 'get',
          url: `v1.1.0/gifshow/anchor/${this.$route.params.anchorId}/liveCalendar`,
          params: { date: `{"$between":[${start},${start + 86399}]}` }
        })
      ])
      this.anchor = anchor
      liveList = liveList?.[0]?.liveStreamLog
      // 日历没有销量，临时加一道
      const commodity = await this.$api({
        method: 'get',
        url: `v1.1.0/gifshow/anchor/${this.$route.params.anchorId}/liveStreamsSales`,
        params: { liveStreamLogIds: JSON.stringify(liveList.map(ele => ele.id)) }
      })
      let salesVolume = 0
      for (const item of commodity) {
        salesVolume += Number(item.totalVolumes)
      }
      // 整日数据得格式化成单场直播的格式💩
      const result = {
        sales: 0,
        salesVolume,
        date: this.$route.params.id,
        startTime: this.$route.params.id,
        poster: liveList?.[0]?.poster,
        uv: 0,
        barrage: { shopCarCommodity: 0, giftCurrency: 0 }
      }
      for (const live of liveList) {
        result.sales += Number(live.sales)
        if (result.uv === 100000 || live.viewsCount === 100000) {
          result.uv = 100000
        } else {
          result.uv += live.viewsCount
        }
        result.barrage.shopCarCommodity += live.shopCarCommodity
        result.barrage.giftCurrency += live.gifts
      }
      this.liveInfo = result
    },
    async getLiveData() {
      const res = await this.$api.get(`v1.1.0/gifshow/anchor/${this.$route.params.anchorId}/liveAnalysis/${this.$route.params.id}`)
      this.liveInfo = res
      this.anchor = res.anchor || {}
      this.commodityList = res?.barrage?.shopCarSalesRanking || []
    },
    createImage() {
      html2canvas(this.$refs.root, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true
      }).then(canvas => {
        this.shadowDisplay = true;
        this.renderSrc = canvas.toDataURL('image/png');
      }).catch(() => {
        this.$toast('分享图生成失败');
      }).finally(() => {
        this.$hideLoading();
      });
    }
  }
}
</script>

<style lang="less">
#live-share-card {
  height: 14.28rem;

  .poster {
    width: 7.5rem;
    height: 7.14rem;
    background-size: cover;
    background-position: center;
  }

  .mirror-bg {
    position: absolute;
    top: 7.14rem;
    left: 0;
    width: 7.5rem;
    height: 7.14rem;
    background-size: cover;
    background-position: center;
    transform: rotateX(180deg);
    z-index: -1;
  }

  .content {
    width: 6.9rem;
    height: 6.48rem;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, #ffffff 50%, #ffffff 100%);
    border-radius: 0.2rem;
    margin: 0 auto;
    padding: .2rem;

    .anchor {
      color: #000000;
      margin-bottom: .2rem;

      .avatar {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        margin-right: .1rem;
        object-fit: cover;
      }

      .name {
        font-size: 0.36rem;
        font-weight: 600;
        margin-bottom: .3rem;
      }

      .time {
        font-size: 0.28rem;
        font-weight: 400;
        color: #000000;
      }
    }

    .statistic {
      background: #ffffff;
      border-radius: 0.08rem;

      .orange {
        display: flex;
        background: rgba(255, 80, 0, .1);
        border-radius: 0.08rem;
        color: #ff5000;
        padding: .3rem 0 .2rem .2rem;
        font-size: .2rem;

        .left {
          .number-font {
            font-size: 0.28rem;
            font-weight: bold;
          }

          .divider {
            width: 2.72rem;
            height: 0.01rem;
            background: #ffffff;
            margin: .3rem 0 .2rem;
          }
        }

        .right {
          margin-left: .43rem;

          .data {
            margin-top: .24rem;

            .number-font {
              font-size: 0.65rem;
              font-weight: bold;
            }
          }
        }
      }

      .blue {
        margin: .2rem 0 .2rem;
        width: 3.15rem;
        height: 1.2rem;
        background: #eaf4fe;
        border-radius: 0.08rem;
        padding: .2rem;
        color: #4a4a4a;
        font-size: 0.2rem;

        .number-font {
          font-size: 0.36rem;
          font-weight: 600;
          color: #000000;
          margin-top: .2rem;
        }
      }
    }

    .no-sales {
      .color-block {
        margin: .2rem 0 .4rem;
        width: 3.15rem;
        height: 1.2rem;
        border-radius: 0.08rem;
        padding: .2rem;
        font-size: 0.2rem;

        .number-font {
          font-size: 0.36rem;
          font-weight: 600;
          margin-top: .2rem;
        }
      }

      .blue {
        background-color: #eaf4fe;
        background-image: url(https://s6.bihukankan.com/img/0326people.png);
        background-size: .8rem .8rem;
        background-repeat: no-repeat;
        background-position: bottom right;
        color: #2a89f4;
      }

      .yellow {
        background-color: #fff4e4;
        background-image: url(https://s6.bihukankan.com/img/0326gift.png);
        background-size: .8rem .8rem;
        background-repeat: no-repeat;
        background-position: bottom right;
        color: #ff9900;
      }

      .detail {
        display: grid;
        grid-template-columns: repeat(3, 2.16rem);
        margin-bottom: .7rem;

        .block {
          width: 2.16rem;
          height: 0.8rem;

          .label {
            font-size: 0.2rem;
            color: #848f9c;
            margin-bottom: .2rem;

            .van-icon {
              vertical-align: bottom;
            }
          }

          .number-font {
            font-size: 0.28rem;
            font-weight: bold;
            color: #4a4a4a;
          }

          &:nth-child(3n+1) {
            padding-left: .2rem;
          }

          &:nth-child(3n+2) {
            text-align: center;
          }

          &:nth-child(3n+3) {
            padding-right: .2rem;
            text-align: right;
          }
        }
      }
    }

    .qrcode-container {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .qr-tips {
        width: 3.48rem;
        height: .96rem;
      }

      .qrcode {
        width: 1.4rem;
        height: 1.4rem;
      }
    }
  }
}

.card {
  .tips {
    background: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 1.2rem;
    padding: 0 0.3rem;
    color: #4a4a4a;
    font-size: 0.28rem;
    z-index: 1;
  }
}
</style>